<div class="white-bg no-padding no-margin">
  <breadcrumbs>
    <breadcrumb route="/" label="{{translate('Dashboard')}}"></breadcrumb>
    <breadcrumb [currentRoute]="true" label="{{translate('Manage Custom Evaluation')}}"></breadcrumb>
  </breadcrumbs>

  <div class="panel_sub_header" style="margin-left: 2%">
    <span class="panel__header__title"> {{"Custom Evaluation ranges do not currently apply to Rope Shovels." | translate | async}}</span>
  </div>
  <div class="page-padding" *ngIf="isEquipmentLevelSelect">
    <header-top [showWval]="showWval"></header-top>

    <div class="spinner" *ngIf="loading">
      <mat-spinner diameter="30"></mat-spinner>
    </div>
      <table class="table table--full-width table--striped table--hover table--sortable" *ngIf="!loading">
        <thead>
          <tr>
            <th><mat-checkbox [checked]="selectAll" (change)="toggleSelectAllEquipment()"></mat-checkbox></th>
            <th>{{"Dealer"| translate | async}}</th>
            <th>{{"Customer"| translate | async}}</th>
            <th>{{"Jobsite"| translate | async}}</th>
            <th>{{"Serial Number"| translate | async}}</th>
            <th>{{"Unit number"| translate | async}}</th>
            <th>{{"Make"| translate | async}}</th>
            <th>{{"Model"| translate | async}}</th>
            <th>{{"Family"| translate | async}}</th>
            <th>{{"Level"| translate | async}}</th>
          </tr>

        </thead>
        <tbody>
          <ng-container  *ngFor="let i of equipmentInspectionResults">
            <tr>
              <td><mat-checkbox [checked]="i.select" (change)="toggleEqSelect(i)"></mat-checkbox></td>
              <td>{{i.Dealer}}</td>
              <td>{{i.Customer}}</td>
              <td>{{i.JobSite}}</td>
              <td>{{i.SerialNo}}</td>
              <td>{{i.UnitNo}}</td>
              <td>{{i.Make}}</td>
              <td>{{i.Model}}</td>
              <td>{{i.Family}}</td>
              <td *ngIf="i.LevelId!=0" style="color: cornflowerblue;">{{i.Level}}</td>
              <td *ngIf="i.LevelId==0">{{i.Level}}</td>

            </tr>
          </ng-container>
        </tbody>
      </table>
    
  </div>
</div>

<div class="page-padding">

  <mat-card>

    <mat-tab-group [(selectedIndex)]="selectedTab">
      <mat-tab [label]="translate('Set Evaluation Ranges')">
        <div style="margin: 16px 0;" *ngIf="selectedTab == 0">
          <div class="panel_sub_header">
            <span class="panel__header__title"> {{"Set Custom Evaluation Ranges" | translate | async}}</span>
          </div>

          <div class="panel__content" style="display: flex; margin-top: 2%;">
            <mat-form-field class="header-form-full-width">
              <mat-select placeholder="{{ Translate('Select Level') }}" (selectionChange)="FilterLevelData($event)">
                <!-- <mat-option [value]="0"></mat-option> -->
                <mat-option *ngFor="let level of EvalLevels" [value]="level">
                  {{ level.LevelName }}
                </mat-option>
              </mat-select>
            </mat-form-field>


            <mat-form-field  class="header-form-full-width" *ngIf="isLevelSelect && isJobsiteLevelSelect ">
              <mat-select placeholder="{{ Translate('Select Customer') }}"(selectionChange)="GetJobsiteForCustomer($event)" >
                 <mat-option [value]="0"></mat-option>
                <mat-option *ngFor="let info of FiteredCustomerList" [value]="info">
                  {{ info.Name }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="header-form-full-width" *ngIf="isLevelSelect">
              <mat-select placeholder="{{levelName | translate | async }}"(selectionChange)="GetEvaluationRange($event)" >
                <mat-option *ngFor="let info of FiteredList" [value]="info">
                  {{ info.Name }}
                </mat-option>
              </mat-select>
            </mat-form-field>

           <div  *ngIf="isEquipmentLevelSelect" style="display: flex;flex-direction: column;">
            <span><b>{{"Equipment Level Selected" | translate | async}}</b></span>
            <span *ngIf="numberofselectedEquipments==0">{{"Please select individual machine from the search field above." | translate | async}}</span>
            <span *ngIf="numberofselectedEquipments>0">{{"Currently applying to" | translate | async}} {{numberofselectedEquipments}} {{"selected machines" | translate | async}}</span>
           </div>
            
         
          </div>
          <div *ngIf="IsDefault && !isEquipmentLevelSelect && selectValue" >
            <span style="color: red;"><b>{{"For your selection the system is currently using the default ranges. These are shown below" | translate | async}}</b></span>
          </div>
          <div *ngIf="IsDefault && isEquipmentLevelSelect && numberofselectedEquipments>1" >
            <span style="color: red;"><b>{{"For your selection site default limits display.These are shown below." | translate | async}}</b></span>
          </div>
          <div *ngIf="isEquipmentLevelSelect && numberofselectedEquipments==1" >
            <span style="color: red;"><b>{{"Limit display for selected machine." | translate | async}}</b></span>
          </div>

          <div *ngIf="!IsDefault && CurrentSelectLevelForRange==4 && selectValue" >
            <span style="color: red;"><b>{{"For your selection the system is currently using the dealer ranges. These are shown below" | translate | async}}</b></span>
          </div>
          <div *ngIf="!IsDefault && CurrentSelectLevelForRange==3 && selectValue" >
            <span style="color: red;"><b>{{"For your selection the system is currently using the customer ranges. These are shown below" | translate | async}}</b></span>
          </div>
          <div *ngIf="!IsDefault && CurrentSelectLevelForRange==2 && selectValue" >
            <span style="color: red;"><b>{{"For your selection the system is currently using the jobsite ranges. These are shown below" | translate | async}}</b></span>
          </div>


          <div style="margin-top: 2%;" *ngIf="selectValue">

            <ng-container>
              <table>
                <tbody>

                  <tr>
                    <td></td>
                    <td>From </td>
                    <td></td>
                    <td>To</td>
                    <td></td>
                    <td><span></span></td>

                    <td></td>
                    <td>From </td>
                    <td></td>
                    <td>To</td>
                    <td></td>
                    <td></td>

                    <td></td>
                    <td>From </td>
                    <td></td>
                    <td>To</td>
                    <td></td>
                    <td></td>
                    <td></td>

                    <td></td>
                    <td>From </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td><b>A</b></td>
                    <td><input class="inputData" type="number" id="A_from" name="A_from" disabled value="0"> </td>
                    <td>%</td>
                    <td><input class="inputData" type="number" id="A_to" name="A_to_" [(ngModel)]="A_to" (change)="Add_A_to($event)"> </td>
                    <td>%</td>
                    <td style="width: 20px;"> </td>

                    <td><b>B</b></td>
                    <td><input class="inputData" type="text" id="B_from" name="B_from_" disabled [(ngModel)]="B_from"> </td>
                    <td>%</td>
                    <td><input class="inputData" type="number" id="B_to" name="B_to_"  [(ngModel)]="B_to" (change)="Add_B_to($event)"> </td>
                    <td>%</td>
                    <td style="width: 20px;"></td>

                    <td><b>C</b></td>
                    <td><input  class="inputData" type="text" id="C_from" name="C_from_" [(ngModel)]="C_from" disabled> </td>
                    <td>%</td>
                    <td><input class="inputData" type="number" id="C_to" name="C_to_" [(ngModel)]="C_to" (change)="Add_C_to($event)" [disabled]="isCExclude"> </td>
                    <td>%</td>
                    <td><mat-checkbox (change)="ChangeExcludeC($event)">Exclude C</mat-checkbox></td>
                    <td style="width: 20px;"></td>

                    <td><b>X</b></td>
                    <td><input class="inputData" type="text" id="X_from" name="X_from_" [(ngModel)]="X_from" disabled> </td>
                    <td>%</td>

                    <td>  <button  mat-raised-button (click)="ApplytoAllComp()" [disabled]="InValid" [class.loading]="applytoall" color="warn">{{Translate('Apply to all Components')}}</button></td>
                   
                    <!-- <td>  <button  mat-raised-button (click)="SaveorUpdate()" [disabled]="InValid" [class.loading]="saving" color="warn">{{Translate('Save/Update')}}</button></td>

                    <td> <a class="button button--primary" (click)="DeleteRange()"><span class="button__text">{{Translate('Delete')}}</span></a></td> -->
                  
                   
                  </tr>
                </tbody>
              </table>
            </ng-container>
            <div style="float: right;"> 
                <button  mat-raised-button (click)="OpenDeleteConfirmation()" class="button-yes">{{Translate('Delete')}}</button>
                <button  mat-raised-button (click)="SaveorUpdate()" [disabled]="InValid" [class.loading]="saving" color="warn">{{Translate('Save/Update')}}</button>
            </div>
          </div>

          <div *ngIf="InValid" > 
            <span style="color: red"> {{'Value should be greater than to the starting range value'  | translate | async}}</span>
          </div>

<hr style="margin-top: 60px;">

<div *ngIf="selectValue">
  <table class="table table--full-width table--striped">
    <thead>
      <tr>
        <th>{{"Component" | translate | async}}</th>
        <th >{{"A Range"| translate | async}}</th>
        <th style="width: 30px;"></th>
        <th>{{"B Range"| translate | async}}</th>
        <th style="width: 30px;"></th>
        <th >{{"C Range"| translate | async}}</th>
        <th style="width: 30px;"></th>
        <th >{{"X Range"| translate | async}}</th>
      </tr>

    </thead>
    <tbody>
      <!--Link-->
      <tr>
        <td>Link</td>
        <td>
          <span>
            <input class="inputData" type="number" id="LinkA_from" name="LinkA_from" disabled value="0">%
          </span>
          <span>
            <input class="inputData" type="number" id="LinkA_to" name="LinkA_to_" [(ngModel)]="LinkA_to" (change)="Add_Link_A_to($event)"> %
          </span>
        </td>
        <td style="width: 30px;"></td>


        <td>
          <span>
            <input class="inputData" type="text" id="LinkB_from" name="LinkB_from" disabled [(ngModel)]="LinkB_from">%
          </span>
          <span>
            <input class="inputData" type="number" id="LinkB_to" name="LinkB_to_" [(ngModel)]="LinkB_to" (change)="Add_Link_B_to($event)"> %
          </span>
        </td>
        <td style="width: 30px;"></td>


        <td>
          <span>
            <input class="inputData" type="text" id="LinkC_from" name="LinkC_from" disabled [(ngModel)]="LinkC_from" >%
          </span>
          <span>
            <input class="inputData" type="number" id="LinkC_to" name="LinkC_to_" [(ngModel)]="LinkC_to" (change)="Add_Link_C_to($event)" [disabled]="isCExclude_Link"> %
          </span>
          <span>
            <mat-checkbox (change)="ChangeExcludeC_Link($event)" [checked]="ChangeExcludeC_LinkC">Exclude C</mat-checkbox>
          </span>
        </td>
        <td style="width: 30px;"></td>

        
        <td>
          <span>
            <input class="inputData" type="text" id="LinkX_from" name="LinkX_from" disabled  [(ngModel)]="LinkX_from">%
          </span>
        </td>
        <td style="width: 30px;"></td>
        

        <td> <a class="button button--primary" (click)="ResetComponentRange('Link')"><span class="button__text">{{Translate('Reset')}}</span></a></td>
      </tr>

      <!--Bush-->
      <tr>
        <td>Bush</td>
        <td>
          <span>
            <input class="inputData" type="number" id="BushA_from" name="BushA_from" disabled value="0">%
          </span>
          <span>
            <input class="inputData" type="number" id="BushA_to" name="BushA_to_" [(ngModel)]="BushA_to" (change)="Add_Bush_A_to($event)"> %
          </span>
        </td>
        <td style="width: 30px;"></td>


        <td>
          <span>
            <input class="inputData" type="text" id="BushB_from" name="BushB_from_" disabled [(ngModel)]="BushB_from">%
          </span>
          <span>
            <input class="inputData" type="number" id="BushB_to" name="BushB_to_" [(ngModel)]="BushB_to" (change)="Add_Bush_B_to($event)"> %
          </span>
        </td>
        <td style="width: 30px;"></td>


        <td>
          <span>
            <input class="inputData" type="text" id="BushC_from" name="BushC_from_" disabled [(ngModel)]="BushC_from" >%
          </span>
          <span>
            <input class="inputData" type="number" id="BushC_to" name="BushC_to_" [(ngModel)]="BushC_to" (change)="Add_Bush_C_to($event)" [disabled]="isCExclude_Bush"> %
          </span>
          <span>
            <mat-checkbox (change)="ChangeExcludeC_Bush($event)" [checked]="ChangeExcludeC_BushC">Exclude C</mat-checkbox>
          </span>
        </td>
        <td style="width: 30px;"></td>

        
        <td>
          <span>
            <input class="inputData" type="text" id="BushX_from" name="BushX_from_" disabled  [(ngModel)]="BushX_from">%
          </span>
        </td>
        <td style="width: 30px;"></td>
        

        <td> <a class="button button--primary" (click)="ResetComponentRange('Bush')"><span class="button__text">{{Translate('Reset')}}</span></a></td>
      </tr>

      <!--Shoe-->
      <tr>
        <td>Shoe</td>
        <td>
          <span>
            <input class="inputData" type="number" id="ShoeA_from" name="ShoeA_from" disabled value="0">%
          </span>
          <span>
            <input class="inputData" type="number" id="ShoeA_to" name="ShoeA_to_" [(ngModel)]="ShoeA_to" (change)="Add_Shoe_A_to($event)"> %
          </span>
        </td>
        <td style="width: 30px;"></td>


        <td>
          <span>
            <input class="inputData" type="text" id="ShoeB_from" name="ShoeB_from_" disabled [(ngModel)]="ShoeB_from">%
          </span>
          <span>
            <input class="inputData" type="number" id="ShoeB_to" name="ShoeB_to_" [(ngModel)]="ShoeB_to" (change)="Add_Shoe_B_to($event)"> %
          </span>
        </td>
        <td style="width: 30px;"></td>


        <td>
          <span>
            <input class="inputData" type="text" id="ShoeC_from" name="ShoeC_from_" disabled [(ngModel)]="ShoeC_from" >%
          </span>
          <span>
            <input class="inputData" type="number" id="ShoeC_to" name="ShoeC_to_" [(ngModel)]="ShoeC_to" (change)="Add_Shoe_C_to($event)" [disabled]="isCExclude_Shoe"> %
          </span>
          <span>
            <mat-checkbox (change)="ChangeExcludeC_Shoe($event)" [checked]="ChangeExcludeC_ShoeC">Exclude C</mat-checkbox>
          </span>
        </td>
        <td style="width: 30px;"></td>

        
        <td>
          <span>
            <input class="inputData" type="text" id="ShoeX_from" name="ShoeX_from_" disabled  [(ngModel)]="ShoeX_from">%
          </span>
        </td>
        <td style="width: 30px;"></td>
        

        <td> <a class="button button--primary" (click)="ResetComponentRange('Shoe')"><span class="button__text">{{Translate('Reset')}}</span></a></td>
      </tr>

      <!--Idler-->
      <tr>
        <td>Idler</td>
        <td>
          <span>
            <input class="inputData" type="number" id="IdlerA_from" name="IdlerA_from_" disabled value="0">%
          </span>
          <span>
            <input class="inputData" type="number" id="IdlerA_to" name="IdlerA_to_" [(ngModel)]="IdlerA_to" (change)="Add_Idler_A_to($event)"> %
          </span>
        </td>
        <td style="width: 30px;"></td>


        <td>
          <span>
            <input class="inputData" type="text" id="IdlerB_from" name="IdlerB_from_" disabled [(ngModel)]="IdlerB_from">%
          </span>
          <span>
            <input class="inputData" type="number" id="IdlerB_to" name="IdlerB_to_" [(ngModel)]="IdlerB_to" (change)="Add_Idler_B_to($event)"> %
          </span>
        </td>
        <td style="width: 30px;"></td>


        <td>
          <span>
            <input class="inputData" type="text" id="IdlerC_from" name="IdlerC_from_" disabled [(ngModel)]="IdlerC_from" >%
          </span>
          <span>
            <input class="inputData" type="number" id="IdlerC_to" name="IdlerC_to_" [(ngModel)]="IdlerC_to" (change)="Add_Idler_C_to($event)" [disabled]="isCExclude_Idler"> %
          </span>
          <span>
            <mat-checkbox (change)="ChangeExcludeC_Idler($event)" [checked]="ChangeExcludeC_IdlerC">Exclude C</mat-checkbox>
          </span>
        </td>
        <td style="width: 30px;"></td>

        
        <td>
          <span>
            <input class="inputData" type="text" id="IdlerX_from" name="IdlerX_from_" disabled  [(ngModel)]="IdlerX_from">%
          </span>
        </td>
        <td style="width: 30px;"></td>
        

        <td> <a class="button button--primary" (click)="ResetComponentRange('Idler')"><span class="button__text">{{Translate('Reset')}}</span></a></td>
      </tr>

      <!--Sprocket-->
      <tr>
        <td>Sprocket</td>
        <td>
          <span>
            <input class="inputData" type="number" id="SprocketA_from" name="SprocketA_from" disabled value="0">%
          </span>
          <span>
            <input class="inputData" type="number" id="SprocketA_to" name="SprocketA_to_" [(ngModel)]="SprocketA_to" (change)="Add_Sprocket_A_to($event)"> %
          </span>
        </td>
        <td style="width: 30px;"></td>


        <td>
          <span>
            <input class="inputData" type="text" id="SprocketB_from" name="SprocketB_from_" disabled [(ngModel)]="SprocketB_from">%
          </span>
          <span>
            <input class="inputData" type="number" id="SprocketB_to" name="SprocketB_to_" [(ngModel)]="SprocketB_to" (change)="Add_Sprocket_B_to($event)"> %
          </span>
        </td>
        <td style="width: 30px;"></td>


        <td>
          <span>
            <input class="inputData" type="text" id="SprocketC_from" name="SprocketC_from_" disabled [(ngModel)]="SprocketC_from" >%
          </span>
          <span>
            <input class="inputData" type="number" id="SprocketC_to" name="SprocketC_to_" [(ngModel)]="SprocketC_to" (change)="Add_Sprocket_C_to($event)" [disabled]="isCExclude_Sprocket"> %
          </span>
          <span>
            <mat-checkbox (change)="ChangeExcludeC_Sprocket($event)" [checked]="ChangeExcludeC_SprocketC">Exclude C</mat-checkbox>
          </span>
        </td>
        <td style="width: 30px;"></td>

        
        <td>
          <span>
            <input class="inputData" type="text" id="SprocketX_from" name="SprocketX_from_" disabled  [(ngModel)]="SprocketX_from">%
          </span>
        </td>
        <td style="width: 30px;"></td>
        

        <td> <a class="button button--primary" (click)="ResetComponentRange('Sprocket')"><span class="button__text">{{Translate('Reset')}}</span></a></td>
      </tr>

      <!--TrackRoller-->
      <tr>
        <td>Track Roller</td>
        <td>
          <span>
            <input class="inputData" type="number" id="TrackRollerA_from" name="TrackRollerA_from" disabled value="0">%
          </span>
          <span>
            <input class="inputData" type="number" id="TrackRollerA_to" name="TrackRollerA_to_" [(ngModel)]="TrackRollerA_to" (change)="Add_TrackRoller_A_to($event)"> %
          </span>
        </td>
        <td style="width: 30px;"></td>


        <td>
          <span>
            <input class="inputData" type="text" id="TrackRollerB_from" name="TrackRollerB_from_" disabled [(ngModel)]="TrackRollerB_from">%
          </span>
          <span>
            <input class="inputData" type="number" id="TrackRollerB_to" name="TrackRollerB_to_" [(ngModel)]="TrackRollerB_to" (change)="Add_TrackRoller_B_to($event)"> %
          </span>
        </td>
        <td style="width: 30px;"></td>


        <td>
          <span>
            <input class="inputData" type="text" id="TrackRollerC_from" name="TrackRollerC_from_" disabled [(ngModel)]="TrackRollerC_from" >%
          </span>
          <span>
            <input class="inputData" type="number" id="TrackRollerC_to" name="TrackRollerC_to_" [(ngModel)]="TrackRollerC_to" (change)="Add_TrackRoller_C_to($event)" [disabled]="isCExclude_TrackRoller"> %
          </span>
          <span>
            <mat-checkbox (change)="ChangeExcludeC_TrackRoller($event)" [checked]="ChangeExcludeC_TrackRollerC">Exclude C</mat-checkbox>
          </span>
        </td>
        <td style="width: 30px;"></td>

        
        <td>
          <span>
            <input class="inputData" type="text" id="TrackRollerX_from" name="TrackRollerX_from_" disabled  [(ngModel)]="TrackRollerX_from">%
          </span>
        </td>
        <td style="width: 30px;"></td>
        

        <td> <a class="button button--primary" (click)="ResetComponentRange('TrackRoller')"><span class="button__text">{{Translate('Reset')}}</span></a></td>
      </tr>

      <!--CarrierRoller-->
      <tr>
        <td>Carrier Roller</td>
        <td>
          <span>
            <input class="inputData" type="number" id="CarrierRollerA_from" name="CarrierRollerA_from" disabled value="0">%
          </span>
          <span>
            <input class="inputData" type="number" id="CarrierRollerA_to" name="CarrierRollerA_to_" [(ngModel)]="CarrierRollerA_to" (change)="Add_CarrierRoller_A_to($event)"> %
          </span>
        </td>
        <td style="width: 30px;"></td>


        <td>
          <span>
            <input class="inputData" type="text" id="CarrierRollerB_from" name="CarrierRollerB_from_" disabled [(ngModel)]="CarrierRollerB_from">%
          </span>
          <span>
            <input class="inputData" type="number" id="CarrierRollerB_to" name="CarrierRollerB_to_" [(ngModel)]="CarrierRollerB_to" (change)="Add_CarrierRoller_B_to($event)"> %
          </span>
        </td>
        <td style="width: 30px;"></td>


        <td>
          <span>
            <input class="inputData" type="text" id="CarrierRollerC_from" name="CarrierRollerC_from_" disabled [(ngModel)]="CarrierRollerC_from" >%
          </span>
          <span>
            <input class="inputData" type="number" id="CarrierRollerC_to" name="CarrierRollerC_to_" [(ngModel)]="CarrierRollerC_to" (change)="Add_CarrierRoller_C_to($event)" [disabled]="isCExclude_CarrierRoller"> %
          </span>
          <span>
            <mat-checkbox (change)="ChangeExcludeC_CarrierRoller($event)" [checked]="ChangeExcludeC_CarrierRollerC">Exclude C</mat-checkbox>
          </span>
        </td>
        <td style="width: 30px;"></td>

        
        <td>
          <span>
            <input class="inputData" type="text" id="CarrierRollerX_from" name="CarrierRollerX_from_" disabled  [(ngModel)]="CarrierRollerX_from">%
          </span>
        </td>
        <td style="width: 30px;"></td>
        

        <td> <a class="button button--primary" (click)="ResetComponentRange('CarrierRoller')"><span class="button__text">{{Translate('Reset')}}</span></a></td>
      </tr>

      <!--RSRearIdler-->
      <tr>
        <td>RS RearIdler</td>
        <td>
          <span>
            <input class="inputData" type="number" id="RSRearIdlerA_from" name="RSRearIdlerA_from" disabled value="0">%
          </span>
          <span>
            <input class="inputData" type="number" id="RSRearIdlerA_to" name="RSRearIdlerA_to_" [(ngModel)]="RSRearIdlerA_to" (change)="Add_RSRearIdler_A_to($event)"> %
          </span>
        </td>
        <td style="width: 30px;"></td>


        <td>
          <span>
            <input class="inputData" type="text" id="RSRearIdlerB_from" name="RSRearIdlerB_from_" disabled [(ngModel)]="RSRearIdlerB_from">%
          </span>
          <span>
            <input class="inputData" type="number" id="RSRearIdlerB_to" name="RSRearIdlerB_to_" [(ngModel)]="RSRearIdlerB_to" (change)="Add_RSRearIdler_B_to($event)"> %
          </span>
        </td>
        <td style="width: 30px;"></td>


        <td>
          <span>
            <input class="inputData" type="text" id="RSRearIdlerC_from" name="RSRearIdlerC_from_" disabled [(ngModel)]="RSRearIdlerC_from" >%
          </span>
          <span>
            <input class="inputData" type="number" id="RSRearIdlerC_to" name="RSRearIdlerC_to_" [(ngModel)]="RSRearIdlerC_to" (change)="Add_RSRearIdler_C_to($event)" [disabled]="isCExclude_RSRearIdler"> %
          </span>
          <span>
            <mat-checkbox (change)="ChangeExcludeC_RSRearIdler($event)" [checked]="ChangeExcludeC_RSRearIdlerC">Exclude C</mat-checkbox>
          </span>
        </td>
        <td style="width: 30px;"></td>

        
        <td>
          <span>
            <input class="inputData" type="text" id="RSRearIdlerX_from" name="RSRearIdlerX_from_" disabled  [(ngModel)]="RSRearIdlerX_from">%
          </span>
        </td>
        <td style="width: 30px;"></td>
        

        <td> <a class="button button--primary" (click)="ResetComponentRange('RSRearIdler')"><span class="button__text">{{Translate('Reset')}}</span></a></td>
      </tr>

    <!--CrawlerGuide-->
      <tr>
        <td>Crawler Frame Guide</td>
        <td>
          <span>
            <input class="inputData" type="number" id="CrawlerGuideA_from" name="CrawlerGuideA_from" disabled value="0">%
          </span>
          <span>
            <input class="inputData" type="number" id="CrawlerGuideA_to" name="CrawlerGuideA_to_" [(ngModel)]="CrawlerGuideA_to" (change)="Add_CrawlerGuide_A_to($event)"> %
          </span>
        </td>
        <td style="width: 30px;"></td>


        <td>
          <span>
            <input class="inputData" type="text" id="CrawlerGuideB_from" name="CrawlerGuideB_from_" disabled [(ngModel)]="CrawlerGuideB_from">%
          </span>
          <span>
            <input class="inputData" type="number" id="CrawlerGuideB_to" name="CrawlerGuideB_to_" [(ngModel)]="CrawlerGuideB_to" (change)="Add_CrawlerGuide_B_to($event)"> %
          </span>
        </td>
        <td style="width: 30px;"></td>


        <td>
          <span>
            <input class="inputData" type="text" id="CrawlerGuideC_from" name="CrawlerGuideC_from_" disabled [(ngModel)]="CrawlerGuideC_from" >%
          </span>
          <span>
            <input class="inputData" type="number" id="CrawlerGuideC_to" name="CrawlerGuideC_to_" [(ngModel)]="CrawlerGuideC_to" (change)="Add_CrawlerGuide_C_to($event)" [disabled]="isCExclude_CrawlerGuide"> %
          </span>
          <span>
            <mat-checkbox (change)="ChangeExcludeC_CrawlerGuide($event)"  [checked]="ChangeExcludeC_CrawlerGuideC">Exclude C</mat-checkbox>
          </span>
        </td>
        <td style="width: 30px;"></td>

        
        <td>
          <span>
            <input class="inputData" type="text" id="CrawlerGuideX_from" name="CrawlerGuideX_from_" disabled  [(ngModel)]="CrawlerGuideX_from">%
          </span>
        </td>
        <td style="width: 30px;"></td>
        

        <td> <a class="button button--primary" (click)="ResetComponentRange('CrawlerGuide')"><span class="button__text">{{Translate('Reset')}}</span></a></td>
      </tr>

      <!--Elongation-->
      <tr>
        <td>Track Elongation</td>
        <td>
          <span>
            <input class="inputData" type="number" id="ElongationA_from" name="ElongationA_from" disabled value="0">%
          </span>
          <span>
            <input class="inputData" type="number" id="ElongationA_to" name="ElongationA_to_" [(ngModel)]="ElongationA_to" (change)="Add_Elongation_A_to($event)"> %
          </span>
        </td>
        <td style="width: 30px;"></td>


        <td>
          <span>
            <input class="inputData" type="text" id="ElongationB_from" name="ElongationB_from_" disabled [(ngModel)]="ElongationB_from">%
          </span>
          <span>
            <input class="inputData" type="number" id="ElongationB_to" name="ElongationB_to_" [(ngModel)]="ElongationB_to" (change)="Add_Elongation_B_to($event)"> %
          </span>
        </td>
        <td style="width: 30px;"></td>


        <td>
          <span>
            <input class="inputData" type="text" id="ElongationC_from" name="ElongationC_from_" disabled [(ngModel)]="ElongationC_from" >%
          </span>
          <span>
            <input class="inputData" type="number" id="ElongationC_to" name="ElongationC_to_" [(ngModel)]="ElongationC_to" (change)="Add_Elongation_C_to($event)" [disabled]="isCExclude_Elongation"> %
          </span>
          <span>
            <mat-checkbox (change)="ChangeExcludeC_Elongation($event)" [checked]="ChangeExcludeC_ElongationC">Exclude C</mat-checkbox>
          </span>
        </td>
        <td style="width: 30px;"></td>

        
        <td>
          <span>
            <input class="inputData" type="text" id="ElongationX_from" name="ElongationX_from_" disabled  [(ngModel)]="ElongationX_from">%
          </span>
        </td>
        <td style="width: 30px;"></td>
        

        <td> <a class="button button--primary" (click)="ResetComponentRange('Elongation')"><span class="button__text">{{Translate('Reset')}}</span></a></td>
      </tr>

      <!--General-->
      <tr>
        <td>General</td>
        <td>
          <span>
            <input class="inputData" type="number" id="GeneralA_from" name="GeneralA_from" disabled value="0">%
          </span>
          <span>
            <input class="inputData" type="number" id="GeneralA_to" name="GeneralA_to_" [(ngModel)]="GeneralA_to" (change)="Add_General_A_to($event)"> %
          </span>
        </td>
        <td style="width: 30px;"></td>


        <td>
          <span>
            <input class="inputData" type="text" id="GeneralB_from" name="GeneralB_from_" disabled [(ngModel)]="GeneralB_from">%
          </span>
          <span>
            <input class="inputData" type="number" id="GeneralB_to" name="GeneralB_to_" [(ngModel)]="GeneralB_to" (change)="Add_General_B_to($event)"> %
          </span>
        </td>
        <td style="width: 30px;"></td>


        <td>
          <span>
            <input class="inputData" type="text" id="GeneralC_from" name="GeneralC_from_" disabled [(ngModel)]="GeneralC_from" >%
          </span>
          <span>
            <input class="inputData" type="number" id="GeneralC_to" name="GeneralC_to_" [(ngModel)]="GeneralC_to" (change)="Add_General_C_to($event)" [disabled]="isCExclude_General"> %
          </span>
          <span>
            <mat-checkbox (change)="ChangeExcludeC_General($event)" [checked]="ChangeExcludeC_GeneralC">Exclude C</mat-checkbox>
          </span>
        </td>
        <td style="width: 30px;"></td>

        
        <td>
          <span>
            <input class="inputData" type="text" id="GeneralX_from" name="GeneralX_from_" disabled  [(ngModel)]="GeneralX_from">%
          </span>
        </td>
        <td style="width: 30px;"></td>
        

        <td> <a class="button button--primary" (click)="ResetComponentRange('General')"><span class="button__text">{{Translate('Reset')}}</span></a></td>
      </tr>

    </tbody>
  </table>
</div>
        </div>
      </mat-tab>
      
    </mat-tab-group>

  </mat-card>
</div>